import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import * as eventActions from 'Actions/events';
import { Box, Link, useMediaQuery } from '@mui/material';
import pianoBackground from '../assets/images/pianoBackground.png';
import HorizontalMobileBlocker from '../assets/images/HorizontalMobileBlocker.png';
import VerticalMobileBlocker from '../assets/images/VerticalMobileBlocker.png';
import Logo from 'Components/Logo';
import { useDispatch } from 'react-redux';
import { ALLOWED_PATHS_ANY_PLATFORM, isCapacitorNative } from 'Utils/Constants';
import { AppDispatch } from 'Reducers';
import { detectDevice } from 'Utils';
import { isCompatibleAndroid, isMobileBrowser, isSafariBrowser } from 'Utils/UserAgent';
import { useNavigate } from 'react-router';
import { MUSEFLOW_OFF_WHITE_1 } from 'Components/Colors';
import LogOutButton from 'Components/LogOutButton';

// Show note that they need to open their browser that is not safari!
const DeviceCompatibilityBlockingScreen = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [showSafariBlockingScreen, setShowSafariBlockingScreen] = useState(false);
  const [showMobileBlockingScreen, setShowMobileBlockingScreen] = useState(false);
  const matchesHeight = useMediaQuery("(min-width:1000px)");
  const matchesWidth = useMediaQuery("(min-height:1000px)");
  
  useEffect(() => {
      // Check paths that allow on any browser
    if (!ALLOWED_PATHS_ANY_PLATFORM.includes(location.pathname)) {
      // Redirect to roadmap which will then show the Mobile/Safari blockers
      if (
        !isCapacitorNative() &&
        (detectDevice() == 'ipad' || detectDevice() == 'iphone') &&
        !location.pathname.includes('verify')
      ) {
        // return <MobileBlockingScreen />;
        console.log("Mobile browser detected, redirecting to roadmap");
        // navigate('/roadmap')
        setShowMobileBlockingScreen(true)
      }
      console.log("isSafariBrowser()", isSafariBrowser(), "&& !location.pathname.includes('verify')", !location.pathname.includes('verify'));
      if (!isCapacitorNative() && isSafariBrowser() && detectDevice() == 'desktop' && !location.pathname.includes('verify')) {
        // return <SafariBlockingScreen />;
        setShowSafariBlockingScreen(true)
        console.log("safari browser detected, redirecting to roadmap");
        // navigate('/roadmap')
      }
    } else {
      setShowMobileBlockingScreen(false)
      setShowSafariBlockingScreen(false)
    }

  }, [location.pathname])

  useEffect(()=>{
    showSafariBlockingScreen && dispatch(eventActions.safariBlockedEventAction());
  }, [showSafariBlockingScreen]);

  
  return (
    <>
    {showSafariBlockingScreen && 
    <Box sx={{
      position: 'fixed',
      inset: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0, 0, 0, 0.80)',
      zIndex: 3000,
    }}>

      <CompatibilityBlockingModal blockingScreen='safari'/>
    </Box>
    }

    {showMobileBlockingScreen && 
      <Box sx={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
      background: 'rgba(0, 0, 0, 0.80)',
      zIndex: 3000,
    }}>

      <CompatibilityBlockingModal blockingScreen='mobile'/>
    </Box>
    }
    </>
  )
}


interface BlockingModalProps {
  blockingScreen: string;
}

const CompatibilityBlockingModal: FC<BlockingModalProps> = ({ blockingScreen }) => {
  return (
    <>
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 2,
        position: 'relative',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
        {blockingScreen === 'safari' && (
           <>
           <Box>
            <Logo absolute={false} href='https://www.museflow.ai' gradient={false}/>
            <Box sx={{
              fontSize: '20px',
              fontWeight: 'bold',
              lineHeight: '145%',
              color: MUSEFLOW_OFF_WHITE_1,
              width: '400px',
              marginTop: '-40px',
            }}>
             To Continue in the web, use Chrome or Edge
             <br/>
             <br/>
              Also available on iPad with our{" "}
            <Link
              href="https://www.apple.com/us/search/museflow?src=globalnav"
              target="_blank"
              rel="noopener noreferrer"
              underline="always"
            >
              iOS App
            </Link>
            </Box>
            </Box>
          
          </>
        )}

        {blockingScreen === 'mobile' && (
            <>
            <Box>
              <Logo absolute={false} href='museflow://' gradient={false}/>
              <Box sx={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: MUSEFLOW_OFF_WHITE_1,
              width: '400px',
              marginTop: '-40px',
              }}>
              Museflow is best experienced on an ipad,
              <br />
              <Link
              href="museflow://"
              target="_blank"
              rel="noopener noreferrer"
              underline="always"
              >
              by downloading the iOS App 
              </Link>
              <br/>
              or on web using Chrome or Edge
              </Box>
            </Box>
            
            </>
        )}
      </Box>
      
      <Box sx={{
        position: 'absolute',
        bottom: '100px',
        left: '100px',
        zIndex: 3002,
        transform: 'scale(1.5)',
        transformOrigin: 'left bottom'
      }}>
        <LogOutButton sx={{}} />
      </Box>
    </Box>
    </>
  )
}


export { DeviceCompatibilityBlockingScreen }
